import { render, staticRenderFns } from "./ClientInfoBlock.vue?vue&type=template&id=6c57469e&scoped=true"
import script from "./ClientInfoBlock.vue?vue&type=script&lang=js"
export * from "./ClientInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57469e",
  null
  
)

export default component.exports